import React from 'react';
import { Link } from 'react-router-dom';
import { BASE } from './links';
// Lo stile del link è condiviso con i componenti Link*, che su questa rotta non sono montati:
// senza questo import il 404 mostrerebbe un link senza stile.
import '../../components/statistiche/Link.css';
import './NonTrovato.css';

/**
 * Uno slug sbagliato o una scheda cancellata devono restituire una via d'uscita, non una pagina
 * vuota: gli URL di questa sezione sono fatti per essere copiati e condivisi, quindi arrivarci
 * male è un caso normale, non un errore del programma.
 */
export default function NonTrovato({ cosa = 'La pagina che cerchi' }) {
  return (
    <div className="statistiche-non-trovato">
      <h1>{cosa} non esiste</h1>
      <p>Forse il link è vecchio, o il nome è cambiato.</p>
      <Link className="stat-link" to={BASE}>Torna alle statistiche</Link>
    </div>
  );
}
